import { Component, h } from '@monygroupcorp/microact';

export class WalletModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
        };
    }

    show() {
        this.setState({ isVisible: true });
    }

    hide() {
        this.setState({ isVisible: false });
    }

    handleWalletClick(walletKey) {
        if (this.props.onWalletSelected) {
            this.props.onWalletSelected(walletKey);
        }
        this.hide();
    }

    /**
     * Render a wallet icon.
     * - data: URI -> <img src>
     * - SVG string -> innerHTML ref
     * - null/undefined -> empty placeholder
     */
    _renderWalletIcon(icon) {
        if (!icon) return h('span', { className: 'wallet-icon' });
        if (typeof icon === 'string') {
            const s = icon.trim();
            if (s.startsWith('data:') || s.startsWith('http') || s.startsWith('/'))
                return h('span', { className: 'wallet-icon' },
                    h('img', { src: s, alt: '' })
                );
        }
        return h('span', { className: 'wallet-icon',
            ref: el => { if (el) el.innerHTML = icon; }
        });
    }

    /**
     * Build wallet list from legacy providerMap + walletIcons props (backward compat).
     * Returns array of { key, name, icon }.
     */
    _buildLegacyWalletList() {
        const walletOptions = Object.keys(this.props.providerMap);
        return walletOptions.map(key => ({
            key,
            name: key.charAt(0).toUpperCase() + key.slice(1),
            icon: this.props.walletIcons ? this.props.walletIcons[key] : null,
        }));
    }

    render() {
        if (!this.state.isVisible) {
            return h('div', { className: 'wallet-modal-container', style: { display: 'none' } });
        }

        // Prefer new `wallets` prop (output of getAvailableWallets()), fall back to legacy
        let walletList;
        if (this.props.wallets && typeof this.props.wallets === 'object') {
            walletList = Object.entries(this.props.wallets).map(([key, w]) => ({
                key,
                name: w.name || key,
                icon: w.icon || null,
            }));
        } else if (this.props.providerMap) {
            walletList = this._buildLegacyWalletList();
        } else {
            walletList = [];
        }

        return h('div', { className: 'wallet-modal-container' },
            h('div', {
                className: 'wallet-modal-overlay',
                onClick: (e) => {
                    if (e.target === e.currentTarget) this.hide();
                }
            },
                h('div', { className: 'wallet-modal' },
                    h('div', { className: 'wallet-modal-header' },
                        h('h3', null, 'Select Your Wallet'),
                        h('button', {
                            className: 'wallet-modal-close',
                            onClick: this.bind(this.hide)
                        }, '\u00D7')
                    ),
                    h('div', { className: 'wallet-options' },
                        walletList.map(wallet =>
                            h('button', {
                                key: wallet.key,
                                className: 'wallet-option',
                                'data-wallet': wallet.key,
                                onClick: () => this.handleWalletClick(wallet.key)
                            },
                                this._renderWalletIcon(wallet.icon),
                                h('span', null, wallet.name)
                            )
                        )
                    )
                )
            )
        );
    }

    static get styles() {
        return `
        .wallet-option .wallet-icon {
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .wallet-option .wallet-icon svg {
            width: 28px;
            height: 28px;
        }

        .wallet-option .wallet-icon img {
            width: 28px;
            height: 28px;
            border-radius: 4px;
        }
        `;
    }
}

export default WalletModal;
